import { s } from './NPL.styles';
import { NplCalculation } from '../../../../utils/nplAnalysis';

interface IExpectedInvestmentPeriodProps {
  expectedInvestmentPeriod: ReturnType<
    NplCalculation['getExpectedInvestmentDays']
  >;
}

const ItemRow = ({
  label,
  content,
}: {
  label: React.ReactNode;
  content: React.ReactNode;
}) => (
  <s.Item>
    <s.ItemLabel>{label}</s.ItemLabel>
    <s.ItemContent>{content}</s.ItemContent>
  </s.Item>
);

const formatDateWithTodayTag = (v?: string) => {
  if (!v) return '-';
  const ymd = v.split(' ')[0]; // "YYYY-MM-DD"
  const now = new Date();
  const today = [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, '0'),
    String(now.getDate()).padStart(2, '0'),
  ].join('-'); // "YYYY-MM-DD"
  const base = formatDate(v);
  return ymd === today ? `(오늘) ${base}` : base;
};

const formatDate = (v?: string) => {
  if (!v) return '-';
  const d = v.split(' ')[0];
  return d.replaceAll('-', '.');
};

const formatDays = (v?: string | number) => {
  if (v == null) return '-';
  const str = String(v).trim();
  return /일$/.test(str) ? str : `${str}일`;
};

const ExpectedInvestmentPeriod = (props: IExpectedInvestmentPeriodProps) => {
  const { expectedInvestmentPeriod } = props;

  const rows = [
    {
      label: '양도, 양수 계약일 (예상)',
      content: formatDateWithTodayTag(expectedInvestmentPeriod.row1_1),
    },
    {
      label: '낙찰일 (예상)',
      content: formatDate(expectedInvestmentPeriod.row2_1),
    },
    {
      label: '배당기일 (예상)',
      content: formatDate(expectedInvestmentPeriod.row1_2),
    },
    {
      label: '투자기간 (예상)',
      content: formatDays(expectedInvestmentPeriod.row2_2),
    },
  ];

  return (
    <s.Div>
      <s.Title>예상 투자기간</s.Title>
      <div>
        {rows.map((r, i) => (
          <ItemRow key={i} label={r.label} content={r.content} />
        ))}
        <s.Description style={{ marginTop: '8px' }}>
          <img
            src="/assets/images/icon/info_16.svg"
            alt=""
            style={{ width: 16 }}
          />
          <span>예상 투자기간은 변동될 수 있습니다.</span>
        </s.Description>
      </div>
    </s.Div>
  );
};

export default ExpectedInvestmentPeriod;
